export const availableLocales = ['th', 'en'] as const
